import Vue from 'vue'
import { createComponentProgrammatic } from '@/helpers/createComponentProgrammatic'


export const MODULE_NAME = 'roadmaps.base-events'

export const createRoadmapBaseEventsModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "RoadmapBaseEventsModal" */
    './components/RoadmapBaseEventsModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}
